export default [
  "126",
  "163",
  "1und1",
  "AOL",
  "DebugMail",
  "DynectEmail",
  "FastMail",
  "GandiMail",
  "Gmail",
  "Godaddy",
  "GodaddyAsia",
  "GodaddyEurope",
  "hot.ee",
  "Hotmail",
  "Hosting90",
  "iCloud",
  "mail.ee",
  "Mail.ru",
  "Maildev",
  "Mailgun",
  "Mailjet",
  "Mailosaur",
  "Mandrill",
  "Naver",
  "OpenMailBox",
  "Outlook365",
  "Postmark",
  "QQ",
  "QQex",
  "SendCloud",
  "SendGrid",
  "SendinBlue",
  "SendPulse",
  "Seznam",
  "SES",
  "SES-US-EAST-1",
  "SES-US-WEST-2",
  "SES-EU-WEST-1",
  "Sparkpost",
  "Yahoo",
  "Yandex",
  "Zoho",
  "qiye.aliyun"
]
